import React from 'react';
import { useTheme } from '../App';
import '../styles/About.css';

const About = () => {
  const { darkMode } = useTheme();

  return (
    <section id="about" className="about-section">
      <div className="section-header">
        <div className="comic-panel-border">
          <div className="about-logo">
            <img
              src={darkMode ? "/images/cardslah-logo-dark-mode.png" : "/images/cardslah-logo.png"}
              alt="CardsLah"
              className="about-logo-image"
            />
          </div>
          <p className="section-tagline">Malaysia's Premier Hub for Trading Card Enthusiasts</p>
        </div>
      </div>

      <div className="about-content">
        <div className="about-panel main-panel">
          <div className="panel-inner">
            <div className="panel-header">
              <span className="panel-number">01</span>
              <h3 className="panel-title">OUR MISSION</h3>
            </div>
            <p className="panel-text">
              Built by collectors, for collectors. CardsLah aims to educate, inspire, and grow
              the Malaysian trading card community. Every card tells a story of passion,
              nostalgia, and the thrill of discovery!
            </p>
            <div className="panel-burst">POW!</div>
          </div>
        </div>

        <div className="about-panels-grid">
          <div className="about-panel">
            <div className="panel-inner">
              <div className="panel-header">
                <span className="panel-number">02</span>
                <h3 className="panel-title">TCG COVERAGE</h3>
              </div>
              <p className="panel-text">
                Featuring Pokemon, Yu-Gi-Oh!, Magic: The Gathering, One Piece, Digimon,
                Dragon Ball, Gundam, sports cards, and more anime-themed collectibles!
              </p>
              <div className="panel-icon trophy"></div>
            </div>
          </div>

          <div className="about-panel">
            <div className="panel-inner">
              <div className="panel-header">
                <span className="panel-number">03</span>
                <h3 className="panel-title">COMMUNITY</h3>
              </div>
              <p className="panel-text">
                Join thousands of fellow collectors and traders! Follow us on Instagram,
                TikTok, and Facebook @cardslah. Connect via our WhatsApp community!
              </p>
              <div className="panel-icon community"></div>
            </div>
          </div>

          <div className="about-panel">
            <div className="panel-inner">
              <div className="panel-header">
                <span className="panel-number">04</span>
                <h3 className="panel-title">CONTENT</h3>
              </div>
              <p className="panel-text">
                Pack openings, card grading insights, chase card hunting tips,
                TCG investment guides, news, and exclusive gallery showcases!
              </p>
              <div className="panel-icon collection"></div>
            </div>
          </div>

          <div className="about-panel">
            <div className="panel-inner">
              <div className="panel-header">
                <span className="panel-number">05</span>
                <h3 className="panel-title">EVENTS</h3>
              </div>
              <p className="panel-text">
                Join our epic events and meetups! Trading sessions, tournaments,
                and collector gatherings across Malaysia.
              </p>
              <div className="panel-icon global"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-social">
        <p className="social-label">CONNECT WITH US:</p>
        <div className="social-links">
          <a href="https://instagram.com/cardslah" target="_blank" rel="noopener noreferrer" className="social-btn instagram">
            <span>Instagram</span>
          </a>
          <a href="https://tiktok.com/@cardslah" target="_blank" rel="noopener noreferrer" className="social-btn tiktok">
            <span>TikTok</span>
          </a>
          <a href="https://facebook.com/cardslah" target="_blank" rel="noopener noreferrer" className="social-btn facebook">
            <span>Facebook</span>
          </a>
        </div>
      </div>

      
      <div className="about-decoration">
        <div className="manga-lines"></div>
        <div className="dot-pattern"></div>
      </div>
    </section>
  );
};

export default About;
